'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdWifi = function MdWifi(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm8.4 21.6c6.4-6.4 16.8-6.4 23.2 0l-3.2 3.4c-4.7-4.6-12.2-4.6-16.8 0z m6.6 6.8c2.7-2.8 7.3-2.8 10 0l-5 5z m-13.4-13.4c10.2-10.1 26.7-10.1 36.8 0l-3.4 3.4c-8.3-8.3-21.7-8.3-30 0z' })
        )
    );
};

exports.default = MdWifi;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/wifi.js
// module id = 2085
// module chunks = 168707334958949